import React, { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from '@src/utils/messages'
import {
  useGlobalSnackbar,
  SnackbarType,
} from '@src/components/GlobalSnackbar/globalSnackBarContext'

import LinkStyleButton from '../LinkStyleButton'
import { AnySiteWideMessage, CtaType } from './types'

interface CtaProps {
  item: AnySiteWideMessage
  dismissMessage: (id: string) => void
  className?: string
}

const PushNotificationsCta: React.FC<CtaProps> = ({
  item,
  dismissMessage,
  className,
}) => {
  const [loading, setLoading] = useState(false)
  const { setGlobalSnackbarState } = useGlobalSnackbar()
  const { formatMessage } = useIntl()
  const onClick = async () => {
    setLoading(true)
    setLoading(false)
    setGlobalSnackbarState({
      open: true,
      message: formatMessage(messages.NOTIFICATIONS_ENABLED),
      variant: SnackbarType.Success,
    })
    dismissMessage(item.id)
  }

  return (
    <LinkStyleButton
      disableRipple
      className={className}
      onClick={onClick}
      disabled={loading}
    >
      {loading ? (
        <>
          <FormattedMessage {...messages.TURNING_ON} />
          ...
        </>
      ) : (
        <FormattedMessage {...messages.TURN_ON} />
      )}
    </LinkStyleButton>
  )
}

export const AemSitewideMessageCta: React.FC<CtaProps> = (props) => {
  // eslint-disable-next-line default-case
  switch (props.item.ctaType) {
    case undefined:
      return null
    case CtaType.PushNotifications:
      return <PushNotificationsCta {...props} />
  }
}
